var map = {
	"./ar/menu.json": 3200,
	"./cz/menu.json": 3006,
	"./de/menu.json": 6456,
	"./en/menu.json": 2048,
	"./es/menu.json": 3321,
	"./fr/menu.json": 2561,
	"./hr/menu.json": 4143,
	"./ja/menu.json": 578,
	"./ko/menu.json": 8935,
	"./kz/menu.json": 6038,
	"./pt/menu.json": 8193,
	"./sh/menu.json": 5084,
	"./sr/menu.json": 6598,
	"./sv/menu.json": 5250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 500;